var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "overflow-y-scroll"
  }, [_c('div', {
    staticClass: "flex flex-col bg-white min-h-full transition-all duration-100 ease-in min-w-64 w-max-content w-max max-w-64 xxl:max-w-80 relative z-10"
  }, [_c('ul', {
    staticClass: "ml-5 mt-32"
  }, _vm._l(_vm.listModulesPages, function (page) {
    return _c('li', {
      key: page.id,
      staticClass: "list-none my-2",
      attrs: {
        "id": page.id
      }
    }, [_c('div', {
      staticClass: "group leading-4 cursor-pointer table flex-wrap h-14 2xl:h-16 w-auto max-w-60 border border-transparent rounded-lg hover:bg-pink-600 hover:text-white focus:outline-none transition ease-in-out duration-150 text-gray-600",
      class: {
        'bg-pink-300': _vm.infosPage.id_page === page.id
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('changePage');
        }
      }
    }, [_c('div', {
      staticClass: "items-center p-4 2xl:p-5 rounded-lg text-indigo-600 group-hover:text-white group-hover:bg-pink-600 transition ease-in-out duration-150 m-1",
      class: {
        'bg-pink-100': _vm.infosPage.id_page === page.id
      }
    }, [_c('icon', {
      attrs: {
        "name": page.icon
      }
    })], 1), _vm._v(" "), _c('router-link', {
      staticClass: "table-cell text-base align-middle pl-1 pr-3 group-hover:text-white",
      class: {
        'text-gray-900': _vm.infosPage.id_page === page.id
      },
      attrs: {
        "to": page.name
      }
    }, [_vm._v("\n            " + _vm._s(page.display_name) + "\n          ")])], 1)]);
  }), 0)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }